import {
  Button,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import ReactMarkdown from "react-markdown"

type Props = {
  title: string
  markdown: string
  onCopy?: () => void
  extraActions?: React.ReactNode
}

const MarkdownResultCard = ({ title, markdown, onCopy, extraActions }: Props) => {
  return (
    <FlexBox
      direction="column"
      gap={SPACING.space3}
      style={{
        border: `1px solid ${JoonUIColor.border.default}`,
        borderRadius: SPACING.space2,
        padding: SPACING.space4,
      }}
    >
      <FlexBox
        direction="row"
        justify="space-between"
        align="center"
        wrap={false}
      >
        <Typography variant="bodyBold" textAlign="left">
          {title}
        </Typography>
        <FlexBox direction="row" gap={SPACING.space2} wrap={false}>
          {extraActions}
          {onCopy && (
            <Button
              text="Copy"
              buttonType="secondary"
              onClick={onCopy}
            />
          )}
        </FlexBox>
      </FlexBox>
      <div className="tools-markdown">
        <ReactMarkdown>{markdown}</ReactMarkdown>
      </div>
    </FlexBox>
  )
}

export default MarkdownResultCard
